import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { Title as o } from "./Title.js";
import { Link as d } from "react-router-dom";
const m = () => /* @__PURE__ */ t(
  "svg",
  {
    width: "24",
    height: "25",
    viewBox: "0 0 24 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ e("path", { d: "M9.57043 19.3201C9.38043 19.3201 9.19043 19.2501 9.04043 19.1001L2.97043 13.0301C2.68043 12.7401 2.68043 12.2601 2.97043 11.9701L9.04043 5.90012C9.33043 5.61012 9.81043 5.61012 10.1004 5.90012C10.3904 6.19012 10.3904 6.67012 10.1004 6.96012L4.56043 12.5001L10.1004 18.0401C10.3904 18.3301 10.3904 18.8101 10.1004 19.1001C9.96043 19.2501 9.76043 19.3201 9.57043 19.3201Z" }),
      /* @__PURE__ */ e("path", { d: "M20.4999 13.25H3.66992C3.25992 13.25 2.91992 12.91 2.91992 12.5C2.91992 12.09 3.25992 11.75 3.66992 11.75H20.4999C20.9099 11.75 21.2499 12.09 21.2499 12.5C21.2499 12.91 20.9099 13.25 20.4999 13.25Z" })
    ]
  }
), f = (s) => {
  const {
    title: a,
    subtitle: r,
    buttons: i,
    buttonsSpacing: c = !0,
    children: l,
    backTo: n
  } = s;
  return /* @__PURE__ */ t("div", { className: "flex items-center justify-between w-full pb-4 mb-4 border-b border-gray-200 dark:text-gray-200 dark:border-gray-400", children: [
    /* @__PURE__ */ t("div", { children: [
      /* @__PURE__ */ e(o, { marginBottom: l || r ? 2 : 0, children: /* @__PURE__ */ t("div", { className: "flex items-center w-full", children: [
        n ? /* @__PURE__ */ e(
          d,
          {
            to: n,
            className: "mr-4",
            title: "Voltar à página anterior",
            children: /* @__PURE__ */ e(m, {})
          }
        ) : null,
        a
      ] }) }),
      r ? /* @__PURE__ */ e(o, { level: 4, marginBottom: l ? 2 : 0, children: r }) : null,
      l
    ] }),
    i ? /* @__PURE__ */ e("div", { className: c ? "flex space-x-4" : void 0, children: i }) : null
  ] });
};
export {
  f as H
};
